/**
 * @param {Mutation} mutation
 * @param {String} name
 * @param {Any} payload
 */
function localStore(mutation, name, payload) {
  if (mutation.type === name) {
    if (payload) window.localStorage.setItem(
      `geodis-${name.toLowerCase()}`,
      window.btoa(encodeURIComponent(JSON.stringify(payload)))
    );
    else window.localStorage.removeItem(
      `geodis-${name.toLowerCase()}`
    );
  }
}

export const storage = store => {
  store.subscribe((mutation, state) => {
    localStore(mutation, 'USER', state.user);
  });
}
